import React from "react";
import { Box, Typography } from "@mui/material";
import { StandardCard } from "../../../../components/Cards";

interface BookingPeriodCardProps {
  label: string;
  subLabel: string;
  value: number;
  isSelected?: boolean;
  onSelect: (bookingPeriod: number) => void;
}

export const BookingPeriodCard: React.FC<BookingPeriodCardProps> = ({
  label,
  subLabel,
  value,
  isSelected = false,
  onSelect,
}) => {
  const handleClick = () => {
    onSelect(value);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onSelect(value);
    }
  };

  return (
    <StandardCard
      sx={{
        mt: 0.5,
        p: 1.25,
        cursor: "pointer",
        transition: "transform 0.2s ease, box-shadow 0.2s ease",
        boxShadow: isSelected ? 4 : 1,
        border: isSelected ? "1px solid" : "1px solid transparent",
        borderColor: isSelected ? "primary.main" : "transparent",
        bgcolor: isSelected ? "primary.main" : "background.paper",
        "&:hover": {
          transform: "translateY(-3px)",
          boxShadow: 4,
        },
      }}
    >
      <Box
        role="button"
        tabIndex={0}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 0.25,
          minHeight: 56,
          width: "100%",
          outline: "none",
        }}
        aria-pressed={isSelected}
      >
        <Typography
          variant="body1"
          fontWeight={600}
          sx={{
            color: isSelected ? "white" : "primary.main",
            fontSize: { xs: "0.9rem", sm: "1.2rem" },
            lineHeight: 1,
            textAlign: "center",
          }}
        >
          {label}
        </Typography>

        <Typography
          variant="body2"
          fontWeight={600}
          sx={{
            color: isSelected ? "white" : "text.secondary",
            fontSize: { xs: "0.75rem", sm: "0.8rem" },
          }}
        >
          {subLabel}
        </Typography>
      </Box>
    </StandardCard>
  );
};
